import React from "react";

const InvoiceDetails = ({data}) => {
  const formatAmount = (value) => {
    return Number(value || 0).toFixed(2);
  };
  const invoiceData = [
    { label: "User State", value: data?.user_state || "---" },
    { label: "Payment Date", value: data?.payment_date || "---" },
    { label: "Invoice Number", value: data?.invoice_number || "---" },
    { label: "Invoice Value", value: formatAmount(data?.invoice_value) },
    { label: "Taxable Amount", value: formatAmount(data?.taxable_amount) },
    { label: "GST(18%)", value: formatAmount(data?.gst_amount) },
    { label: "S-GST", value: -formatAmount(data?.sgst) },
    { label: "C-GST", value: -formatAmount(data?.cgst) },
    { label: "IGST", value: -formatAmount(data?.igst) },
    {
      label: "Payment Gateway Fee",
      value: -formatAmount(data?.payment_gateway_fee),
    },
    // { label: "Wallet Amount", value: formatAmount(data?.wallet_amount) },
    // { label: "Coupon Amount", value: formatAmount(data?.coupon_amount) },
    // {
    //   label: "Online Paid Amount",
    //   value: formatAmount(data?.online_paid_amount),
    // },
    {
      label: "Vow Final Profit",
      value: formatAmount(data?.final_vow_profit),
      bold: true,
    },
  ];


  return (
    <div style={styles.container}>
      <h3
        className="d-flex f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 "
        style={styles.title}
      >
        Invoice Details
      </h3>

      {invoiceData.map((item, index) => (
        <div key={index} style={styles.row}>
          <span
            className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray col-md-6"
            style={styles.label}
          >
            {item.label}
          </span>

          <span
            class="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2"
            style={{
              ...styles.value,
              fontWeight: item.bold ? "700" : "500",
            }}
          >
            {item.value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default InvoiceDetails;

const styles = {
  container: {
    width: "50%",
    // padding: "14px",
    border: "1px solid #d9d9d9",
    borderRadius: "12px",
    // backgroundColor: "#fff",
    // // backgroundColor: "#f8f8f8",
        fontFamily: "sans-serif",
    
    //   maxHeight: '150vh',
    // overflow: scroll;
    backgroundColor: '#fff',
    boxShadow: 'rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px',
    padding: '10px 20px'
,height:"auto"
    },

  title: {
    margin: "0 0 14px",
    fontSize: "16px",
    fontWeight: "600",
    color: "#222",
  },

  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
  },

  label: {
    fontSize: "14px",
    color: "#9a9a9a",
  },

  value: {
    fontSize: "15px",
    color: "#111",
  },
};
